import React from "react";

export default function TextInput({
  label,
  value,
  onChange,
  readOnly = false,
  placeholder = "",
  error,
}) {
  return (
    <div className="form-group">
      <label>{label}:</label>
      <input
        type="text"
        value={value}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.target.value)}
      />
      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
